import { createContext, useContext, useReducer } from "react";
import { getLocal, setLocal } from "../utils/localStorageCache";

const KEY_AUTH_STATE = "kystdatahuset_auth_state";

function setAuthState(state) {
  return setLocal(KEY_AUTH_STATE, state);
}

export function getAuthState() {
  var savedState = getLocal(KEY_AUTH_STATE, 60 * 72);
  try {
    if (savedState) {
      savedState.expiration_time = new Date(savedState.expiration_time);
      return savedState;
    } else {
      throw new Error("No saved authentication data");
    }
  } catch (e) {
    console.info(e);
    savedState = { ...defaultAuthState };
    setAuthState(savedState);
  }
}

const defaultAuthState = {
  authenticated: false,
  name: null,
  gm_session_id: null,
  jwt: null,
  roles: [],
  expiration_time: new Date(),
};

function authReducerFunc(state, action) {
  var mState;
  switch (action.type) {
    case "login":
      mState = {
        ...state,
        authenticated: true,
        name: action.name,
        roles: action.roles,
        gm_session_id: action.gm_session_id,
        jwt: action.jwt,
        expiration_time: action.expiration_time,
      };
      break;
    case "logout":
    default:
      mState = {
        ...defaultAuthState,
      };
      break;
  }
  setAuthState(mState);
  return mState;
}

/**
 * Auth context
 */
export const AuthContext = createContext();

/**
 * Context provider component
 * @param {*} param0
 */
export function AuthContextProvider({ children }) {
  const authCtx = useReducer(authReducerFunc, getAuthState());

  return (
    <AuthContext.Provider value={authCtx}>{children}</AuthContext.Provider>
  );
}

/**
 * Do not display children unless user is authenticated
 *
 */
export function RequireLogin({ children }) {
  const [authState] = useContext(AuthContext);
  if (
    authState.authenticated !== true ||
    authState.expiration_time <= new Date()
  )
    return null;

  return <>{children}</>;
}

/**
 * Do not display children unless no user is authenticated
 *
 */
export function RequireAnonymous({ children }) {
  const [authState] = useContext(AuthContext);
  if (
    authState.authenticated === true &&
    authState.expiration_time > new Date()
  )
    return null;

  return <>{children}</>;
}
